import { User } from 'src/screens/user/Users';

import { Product } from './product';

export interface Logistics {
  id: number;
  productId: number;
  address: string;
  orderId: number;
  userId: number;
  user: User;
  status: LogisticsStasus;
  company: string;
  trackingNumber: string;
  product: Product;
  createdAt: Date;
}

export enum LogisticsStasus {
  AWAITING_DELIVERY,
  SHIPPED,
  CANCELED, // 已取消
  RETURNED, // 已退回
}



// WEBPACK FOOTER //
// ./src/types/logistics.ts